import { Component } from '@theme/component';
import { drawSchita } from '@theme/perdele-calc-schita';

/**
 * Schemele din textele fixe ale paginii de produs (blocul `perdele-produs-info-fixe`), desenate cu aceeași piesă ca
 * schița calculatorului (`perdele-calc-schita.js`): „ce măsori” (fereastra, șina, cotele explicate) și cele trei
 * bogății ×1 / ×1,5 / ×2 pe aceeași șină de 3 m. SVG-urile au raportul rezervat din CSS, deci desenul nu mută pagina.
 *
 * @extends {Component}
 */
class PerdeleInfoComponent extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#deseneaza();
  }

  updatedCallback() {
    super.updatedCallback();
    this.#deseneaza();
  }

  #deseneaza() {
    const kind = this.dataset.kind || 'draperie';
    const color = this.dataset.culoare || null;
    for (const svg of this.querySelectorAll('svg[data-schita]')) {
      if (!(svg instanceof SVGSVGElement)) continue;
      const { schita } = svg.dataset;
      if (schita === 'masurare') {
        drawSchita(svg, 300, 240, {
          layers: [],
          grip: 'rejansa-sina-galerie',
          id: 'perdeleInfoMasurare',
          explica: { latime: svg.dataset.latime, inaltime: svg.dataset.inaltime, geam: svg.dataset.geam },
        });
        continue;
      }
      const factor = Number(svg.dataset.factor) || 1;
      // la set, schița mică arată draperia (stratul care se vede); voalul e același mecanism
      const layers = [{ kind: kind === 'perdea' ? 'voal' : 'draperie', factor, pieces: 1, color, accent: true }];
      drawSchita(svg, 300, 240, {
        cote: false,
        layers,
        grip: 'rejansa-sina-galerie',
        id: `perdeleInfoBogatie${String(factor).replace('.', '_')}`,
      });
    }
  }
}

if (!customElements.get('perdele-info-component')) {
  customElements.define('perdele-info-component', PerdeleInfoComponent);
}
